// extracted by mini-css-extract-plugin
export default {"pageContent":"resources_pageContent__HEs6e"};